import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';

import { DatagridComponent } from './datagrid.component';
import { DatagridFiltersComponent } from './datagrid-filters/datagrid-filters.component';
import { DatagridHeaderComponent } from './datagrid-header/datagrid-header.component';
import { DatagridTableComponent } from './datagrid-table/datagrid-table.component';
import { DatagridFilterPipe } from './shared';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    MaterialModule
  ],
  exports: [
    DatagridComponent
  ],
  declarations: [
    DatagridComponent,
    DatagridFiltersComponent,
    DatagridHeaderComponent,
    DatagridTableComponent,
    DatagridFilterPipe
  ]
})
export class DatagridModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/datagrid/datagrid.module.ts